export default {
  UPDATE_BASE_GOALS_COMMAND: Symbol.for('UPDATE_BASE_GOALS_COMMAND'),
  BASE_GOALS_REPOSITORY: Symbol.for('BASE_GOALS_REPOSITORY'),
};
